import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ECharts from "vue-echarts";
import ElementUI from 'element-ui';
import EleMultiCascader from "ele-multi-cascader";
import axios from 'axios';
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/common.scss";
import eIconPicker from 'e-icon-picker';
import "e-icon-picker/lib/symbol.js"; //基本彩色图标库
import 'e-icon-picker/lib/index.css'; // 基本样式，包含基本图标
import 'font-awesome/css/font-awesome.min.css'; //font-awesome 图标库
import 'element-ui/lib/theme-chalk/icon.css'; //element-ui 图标库
import Print from 'vue-print-nb'
Vue.use(Print);

Vue.use(eIconPicker,{
    FontAwesome: true,//fontAwesome 4.7 整理后的图标集
    ElementUI: true,//elementUI 整理后的图标集
    eIcon: true,//自带的图标，来自阿里妈妈
    eIconSymbol: true,//是否开启彩色图标
    addIconList: [],
    removeIconList: [],
    zIndex: 9100//选择器弹层的最低层,全局配置
});

Vue.use(ElementUI);
Vue.component('v-chart', ECharts)//全局注册

Vue.use(EleMultiCascader);

Vue.config.productionTip = false;
Vue.prototype.$axios = axios


Vue.directive('has', {
    inserted:  (el, binding) =>{
        setTimeout(() => {
            const authorities = store.getters.getter_menusStore;
            if(authorities.indexOf(binding.value) < 0){
                el.parentNode?.removeChild(el)
            }
        }, 100)
    }
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
